export default "复制\r\n"